export default "__VITE_ASSET__8f30ca45__"